import React, { useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import {
    Box, 
    Accordion,
    AccordionSummary,
    AccordionDetails,
    useMediaQuery,
} from "@mui/material";

import { isEmpty, getCookie } from "weed-js";

import { IntegrationDropdowns } from "./IntegrationDropdowns.js";
import {useSelector} from "react-redux";
import {INTEGRATIONS} from "../../constants";

import "./style.css";

export const IntegrationSelector = ({ loggedInUser, organizations, subscriptions}) => {
    const [expanded, setExpanded] = useState(false);

    const selectedOrganization = useSelector(state => state.organizationReducer.selectedOrganization);
    const selectedIntegration = useSelector(state => {
        return isEmpty(state.integrationReducer.selectedIntegration) ? INTEGRATIONS.find(i => i == getCookie("integration")) : state.integrationReducer.selectedIntegration;
    });
    const selectedIntegrationAccounts = useSelector(state => state.integrationReducer.accounts.selectedAccounts);

    let parts = [];
    if (!isEmpty(selectedOrganization)) {
        parts.push(selectedOrganization.name);
    }
    if (!isEmpty(selectedIntegration)) {
        parts.push(selectedIntegration);
    }
    if (!isEmpty(selectedIntegrationAccounts)) {
        parts.push(
            selectedIntegrationAccounts.map(sia => sia.display_name).join("|")
        );
    }

    const isMobile = useMediaQuery("(max-width:1000px)");

    const title = isMobile 
        ? isEmpty(parts) 
            ? "Choose an organization/integration/stores here." 
            : parts.join(" > ")
        : isEmpty(parts)
            ? "Choose an organization/integration/stores here." 
            : "You're currently viewing: " + parts.join(" > ") + ". Click here to switch."
    ;

    return (isEmpty(loggedInUser) || isEmpty(organizations))
        ? <></>
        : <Box className={"integration-selector"}>
            <Accordion>
                <AccordionSummary
                    expandIcon={expanded ? <ExpandMoreIcon/> : <ExpandLessIcon/>}
                    aria-controls="menu-content"
                >
                    <p className={"integration-selector-accordion-title"}>{title}</p>
                </AccordionSummary>
                <AccordionDetails>
                    <IntegrationDropdowns subscriptions={subscriptions}/>
                </AccordionDetails>
            </Accordion>
        </Box>;
};

export default IntegrationSelector;